import * as React from "react";
import { Cascader } from "antd";
import { connect } from "react-redux";
import { getCity } from "utils/interface";
import { CQ } from "utils/commonQuest";

interface IRegionCascaderProps {
  width?: number;
  getCountry?: any;
  getCity?: any;
  resetCity?: any;
  setValue?: any;
  share?: any;
  // 默认值
  defaultValue?: any;
  value?: any;
  style?: React.CSSProperties;
  // 自定义字段，映射viewModel的字段
  "data-field"?: any;
  "city-field"?: any;
  "area-field"?: any;
  // 当此项为 true 时，点选每级菜单选项值都会发生变化
  changeOnSelect?: boolean;
  isLoadCity?: any;
  modelName?: any;
  onChange?: any;
  // redux中管理的表单数据
  reduxFormData?: any;
  // 用于找到父节点的选择器
  containerBody?: any;
}

class RegionCascader extends React.Component<IRegionCascaderProps, any> {
  state = {
    options: [],
    countryId: null
  };

  constructor(props: IRegionCascaderProps) {
    super(props);
  }

  componentDidMount() {
    this.props.getCountry && this.props.getCountry();
  }

  // 选完数据后触发
  onChange = (value, selectedOptions) => {
    let data = {};
    data[this.props["data-field"]] = value[0];
    data[this.props["city-field"]] = value[1];
    this.setState({
      countryId: value[0]
    });
    this.props.setValue({
      formInfo: data,
      model: this.props.modelName
    });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.country.length === prevState.options.length) {
      return null;
    }

    let options = [];
    options = nextProps.country.map(item => {
      let state = {
        label: item.name,
        value: item.id,
        isLeaf: false
      };

      return state;
    });
    return {
      options
    };
  }

  loadData = selectedOptions => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    if (targetOption.loading) return;
    targetOption.loading = true;

    // setTimeout(() => {
    //   this.props.getCity && this.props.getCity();
    // }, 1000);

    console.log("国家信息", targetOption);
    async function getData(_this) {
      const data = await CQ(getCity({ pid: targetOption.value }));
      let children = [];

      if (data && data.length > 0) {
        children = data.map(item => {
          return {
            label: item.name,
            value: item.id
          };
        });
      }

      targetOption.loading = false;
      targetOption.children = children;
      _this.setState({
        options: [..._this.state.options]
      });
    }

    getData(this);
  };

  filter = (inputValue, path) => {
    return path.some(
      option =>
        option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );
  };

  getContainer = () => {
    const containerBody = this.props.containerBody;
    if (containerBody) {
      return document.querySelector(containerBody) || document.body;
    } else {
      return document.body;
    }
  };

  onPopupVisibleChange = value => {
    const country = this.props.reduxFormData[this.props.modelName][
      this.props["data-field"]
    ];
    // 当国家未被选中过并且浮窗是打开状态时，默认选中第一个国家
    // 这样处理可以使二级菜单默认打开节省客服多次选择的时间
    if (value && !!!country && this.state.options != null) {
      setTimeout(() => {
        const li: any = document.querySelector(
          ".region__popup .ant-cascader-menu:first-child li:first-child"
        );
        if (li) li.click();
      }, 50);
    }
  };

  render() {
    let value: any = [];
    const country = this.props.reduxFormData[this.props.modelName][
        this.props["data-field"]
      ],
      city = this.props.reduxFormData[this.props.modelName][
        this.props["city-field"]
      ];

    if (country || city) {
      value = [country, city];
    } else {
      value = [];
    }
    // console.log("浮窗内数据1111", value);
    return (
      <Cascader
        options={this.state.options}
        value={value}
        className="region"
        popupClassName="region__popup"
        loadData={this.loadData}
        onChange={this.onChange}
        style={{ width: this.props.width || 220 }}
        //changeOnSelect
        changeOnSelect={this.props.changeOnSelect || true}
        showSearch={{ filter: this.filter }}
        placeholder="国家城市"
        onPopupVisibleChange={this.onPopupVisibleChange}
        getPopupContainer={this.getContainer}
      />
    );
  }
}

const mapState = state => ({
  reduxFormData: state.antDemo,
  country: state.share.country,
  city: state.share.city
});

const mapDispatch = dispatch => {
  return {
    getCountry: dispatch.region.getCountry,
    getCity: dispatch.region.getCity,
    // 重置城市数据
    resetCity: dispatch.share.resetCity,
    setValue: dispatch.antDemo.setValue
  };
};

export default connect(
  mapState,
  mapDispatch
)(RegionCascader);
